export default {
	install: function(app, options) {
		app.config.globalProperties.$can = (action) => {
			// permissions come from the options injected in app.js to the 'can' plugin
			let permissions = options.value;
			return permissions.includes(action) ? true : false;
		}
	}
}